import React, { FC } from 'react';
import { connect } from 'react-redux';
import { isSupplierPayingCustomer } from '../../utils/DataAccessUtils';
import ClientsProUpsellPanel from './ClientsProUpsellPanel';

// Wraps a Clients tab component so it's gated behind Supplier Pro: paying suppliers
// get the real page; everyone else gets the inline upsell panel (the tab stays
// clickable). Used for the All / All Locations tabs; Compliance is left ungated.
const withSupplierProGate = (WrappedComponent: any, feature?: string) => {
	const SupplierProGate: FC<any> = ({ isPaying, ...rest }): React.ReactElement =>
		isPaying ? <WrappedComponent {...rest} /> : <ClientsProUpsellPanel feature={feature} />;

	return connect((state: any) => ({
		isPaying: isSupplierPayingCustomer(nullSafeCurrentUser(state)),
	}))(SupplierProGate);
};

// currentUser is always present once authenticated, but guard so isSupplierPayingCustomer
// (which reads currentUser.userType) never throws during transient logged-out renders.
const nullSafeCurrentUser = (state: any) =>
	(state && state.session && state.session.currentUser) || {};

export default withSupplierProGate;
